<template>
    <div v-if="show" class="kuaishou-text-ad" @click="handleClick">
        <img class="icon" src="@/assets/volume-notice.png" />
        <div class="content">{{ text }}</div>
        <!-- <div class="arrow">点击查看>>></div> -->
    </div>
</template>

<script>
import { getActivity } from '@/api';
import ScTrack from '@/utils/track'
import { isKuaishouSearch } from '@/utils/kuaishouQuery'

export default {
    name: 'KuaishouTextAd',
    data() {
        return {
            show: false,
            text: '',
            linkUrl: '',
        };
    },
    created() {
        this.loadScript();
    },
    mounted() {
        this.checkChannel();
    },
    methods: {
        loadScript() {
            const ele = document.createElement("script");
            ele.src = 'https://upload.chongnengjihua.com/production/jfnpm/sa-track/1.0.3/jftrack.min.js';
            // 加载完后，调用进入页面埋点
            ele.onload = () => {
                ScTrack.getInstance().track('enter_mobile_world_index_page');
            };
            document.body.appendChild(ele);
        },
        async checkChannel() {
            console.log('isKuaishouSearch(this.$route.query)',isKuaishouSearch(this.$route.query))
            if (isKuaishouSearch(this.$route.query)) {
                await this.fetchActivity();
            }
        },
        async fetchActivity() {
            try {
                let res = await getActivity({
                    position: '9fztgw_ks_ad1',
                    activityStatus: 'NOW',
                    hiddenStatus: 'SHOWN'
                });


                if (res && res.list && res.list.length > 0) {
                    const activity = res.list[0];
                    // 使用 title 作为显示文本
                    this.text = activity.title;
                    this.linkUrl = activity.link;
                    this.show = true;

                    // 埋点-展示
                    this.$nextTick(() => {
                         ScTrack.getInstance().track('exposure_ad_show', {
                            position_id: '9fztgw_ks_ad1',
                            material_title: this.text,
                            material_url: this.linkUrl
                        })
                    })
                }
            } catch (e) {
                console.error('Fetch Kuaishou text ad failed', e);
            }
        },
        handleClick() {
            // 埋点-点击
            ScTrack.getInstance().track('exposure_ad', {
                position_id: '9fztgw_ks_ad1',
                material_title: this.text,
                material_url: this.linkUrl
            })

            if (this.linkUrl) {
                window.location.href = this.linkUrl;
            }
        }
    }
};
</script>

<style lang="stylus" scoped>
.kuaishou-text-ad {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 3.5px 6px;
    // height: 40px;
    background: #fff;
    border-top: 1px solid #F5F5F5;
    border-bottom: 1px solid #F5F5F5;
    cursor: pointer;
    background-color: #fff6ed;

    .icon {
        width: 16px;
        height: 16px;
        margin-right: 4px;
    }

    .content {
        flex: 1;
        font-size: 14px;
        color: #B1542E;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        margin-bottom: 2px;
    }

    .arrow {
        font-size: 13px;
        color: #E93030;
        margin-left: 4px;
    }
}
</style>
